module.exports = __webpack_public_path__ + "media/zq-cn.6b9f0e85.mp3";